<template>
  <div class="WarehouseOperation">
    <template v-if="orderDetail.status!==ORDERSTATUS.draft&&orderDetail.status!==ORDERSTATUS.expStatus&&orderDetail.warehouseOrderResList&&orderDetail.warehouseOrderResList.length >0">
      <template v-if="!orderDetail.isWarehouseMultiDischargeOrder">
        <div class="btnBox">
        <span v-for="(item, index) in dispatchList" :key="index">
          <a
            :class="['operation-type', nextIndex === index ? 'active' : '']"
            :type="nextIndex === index ? 'primary' : ''"
            @click="onCheckout(index)"
          >
            <img :src="nextIndex === index ? activeIcon : normalIcon" alt="">
            {{item.name}}
          </a>
          <a-icon v-if="index !== dispatchList.length - 1" type="arrow-right" />
        </span>
      </div>
      <div class="title_bar">{{dispatchList[nextIndex].name + '概况'}}</div>
        <div  class="OrderOutData">
          <OrderOutData
            :index="0"
            :title="dispatchList[nextIndex].name"
            :dispatch-list="dispatchList" 
            :order-detail="orderDetail"
            :table-data="listData"
            :is-now-wa-customer="isNowWaCustomer"
            :warehouse-order-res-list="warehouseOrderResList" >
            <template slot="info">
                  <div v-if="orderDetail.fileList.length > 0" class="attachment flex">
                    <span>附件信息</span>
                    <div>
                      <a @click="downloadDetails({url: '/order/file/package/download', name: `${orderDetail.unifyOdrNo}.zip`})">下载全部</a>
                      <div class="attachment-list">
                        <div v-for="(file) in orderDetail.fileList" :key="file.id" class="list-item flex justify-between">
                          <div>
                            <i class="iconfont icon-icon_file_14x14 icon_file" />
                            <span class="fileNameStyle">{{file.imgName}}</span>
                          </div>
                          <a @click="downloadDetails({imgurl:file.imgUrl, name:file.imgName, type: true,url: '/order/file/download'})">
                            <i class="iconfont icon-icon_download_16x16 icon_download" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
          </OrderOutData>
        </div>
      </template>
       <template v-else>
        <div class="btnBox">
        <span v-for="(item, index) in MultiDispatchList"
          :key="index">
          <a
            :class="['operation-type', nextIndex === index ? 'active' : '']"
            :type="nextIndex === index ? 'primary' : ''"
            @click="onCheckout(index)"
          >
            <img :src="nextIndex === index ? activeIcon : normalIcon" alt="">
            {{item.name}}
          </a>
          <a-icon v-if="index !== MultiDispatchList.length - 1" type="arrow-right" />
        </span>
        </div>
         <div class="title_bar">{{MultiDispatchList[nextIndex].name + '概况'}}</div>
          <template v-for="(item,index) in warehouseMultiOrderResList">
            <div :key="index"  class="OrderOutData">
              <OrderOutData
              :index="index"
              :title="MultiDispatchList[nextIndex].name"
              :dispatch-list="MultiDispatchList" 
              :order-detail="orderDetail"
              :is-now-wa-customer="isNowWaCustomer"
              :table-data="warehouseGoodsListMultiDischarge(item)"
              :warehouse-order-res-list="item" >
                <template slot="info">
                  <div v-if="orderDetail.fileList.length > 0" class="attachment flex">
                    <span>附件信息</span>
                    <div>
                      <a @click="downloadDetails({url: '/order/file/package/download', name: `${orderDetail.unifyOdrNo}.zip`})">下载全部</a>
                      <div class="attachment-list">
                        <div v-for="(file) in orderDetail.fileList" :key="file.id" class="list-item flex justify-between">
                          <div>
                            <i class="iconfont icon-icon_file_14x14 icon_file" />
                            <span class="fileNameStyle">{{file.imgName}}</span>
                          </div>
                          <a @click="downloadDetails({imgurl:file.imgUrl, name:file.imgName, type: true,url: '/order/file/download'})">
                            <i class="iconfont icon-icon_download_16x16 icon_download" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </OrderOutData>
            </div>
          </template>
      </template>
    </template>
    <div v-else class="no-data">暂未生成仓库作业单据，请稍后查看</div>
    </div>
</template>

<script>
import moment from 'moment'
import { getToken } from "@/utils/auth";
import activeIcon from '@/assets/img/icon_chuku_active.png'
import normalIcon from '@/assets/img/icon_chuku_normal.png'
import Service from "../../../../env/index.js";
import OrderOutData from './components/OrderOutData.vue'
import {ORDERSTATUS} from '../warehouseList/constant'

const warehouseType = {
  DELIVER_DRAFT: "出库草稿",
  DELIVERING: "出库中",
  DELIVER_FINISH: "出库完成",
  STORE_DRAFT: "入库草稿",
  STORING: "入库中",
  STORE_FINISH: "入库完成",
  CANCEL: "取消"
}
const orderType = {
  CK: '出库',
  RK: '入库',
  DB: '调拨',
}
export default {
  name: 'WarehouseOperation',
  components: {
    OrderOutData
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => ({}),
    },
    isNowWaCustomer:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      activeIcon,
      normalIcon,
      warehouseType,
      ORDERSTATUS,
      odrNo: this.$route.query.unifyOdrNo,
      // orderDetail: null,
      orderType,
      nextIndex: 0,
      goodsTableColums: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          width: 60,
          scopedSlots: { customRender: 'indexNum' },
          customRender: (value, row) => {
            return {
                children: value,
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: '货品',
          dataIndex: 'skuName',
          key: 'skuName',
          width: 200,
          customRender: (value, row) => {
            return {
                children: value,
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: '指定批次',
          dataIndex: 'stockBatch',
          key: 'stockBatch',
          width: 100
        },
        {
          title: '计划量',
          dataIndex: 'planAmount',
          key: 'planAmount',
          width: 100,
          customRender: (value, row) => {
            return {
                children: value !== null ? `${value}${row.wmsExt?.goodsUnit || row.wmsExt?.goodUnit || '--'}` : '',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: `出库量`,
          dataIndex: 'finishAmount',
          key: 'finishAmount',
          width: 100,
          customRender: (value, row) => {
            return {
                children: value !== null ? `${value}${row.wmsExt?.goodsUnit || row.wmsExt?.goodUnit || '--'}` : '',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
      ],
      goodsTableColumsIn: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          width: 60,
          scopedSlots: { customRender: 'index' },
          customRender: (value, row) => {
            return {
                children: value,
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: '货品',
          dataIndex: 'skuName',
          key: 'skuName',
          width: 200,
          customRender: (value, row) => {
            return {
                children: value,
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: '指定批次',
          dataIndex: 'stockBatch',
          key: 'stockBatch',
          width: 100
        },
        {
          title: '计划量',
          dataIndex: 'planAmount',
          key: 'planAmount',
          width: 100,
          customRender: (value, row) => {
            return {
                children: value !== null ? `${value}${row.skuUnit || '--'}` : '',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
        {
          title: `入库量`,
          dataIndex: 'finishAmount',
          key: 'finishAmount',
          width: 100,
          customRender: (value, row) => {
            return {
                children: value !== null ? `${value}${row.skuUnit || '--'}` : '',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
          },
        },
      ],
    }
  },
  computed: {
    MultiDispatchList(){
      if(!this.orderDetail || !this.orderDetail.warehouseOrderResList) return []
      const data=[]
       this.orderDetail.warehouseOrderResList.forEach((e)=>{
        if(!data.some(item=>item.name===orderType[e.orderType])){
          data.push({...e,name:orderType[e.orderType]})
        }
      })
      return data
    },
    dispatchList(){
      if(!this.orderDetail || !this.orderDetail.warehouseOrderResList) return []
      const data = this.orderDetail.warehouseOrderResList.map((e)=>{
        return {
          name: orderType[e.orderType]
        }
      })
      return data
    },
    warehouseOrderResList() {
       const data = this.orderDetail && this.orderDetail.warehouseOrderResList.length > 0 ? this.orderDetail.warehouseOrderResList[this.nextIndex] : {}
      return data
      
    },
    warehouseMultiOrderResList(){
       const wOrderType={
        0:'CK',
        1:'RK'
      }
      const data = this.orderDetail&& this.orderDetail.warehouseOrderResList.length>0?this.orderDetail.warehouseOrderResList.filter(item=>item.orderType===wOrderType[this.nextIndex]):[]
      return data
    },
    warehouseGoodsListMultiDischarge(){
      return (row)=>{
        const data = this.concatList(row.warehouseOrderGoodsList, 'skuId')
        const tableList = []
        data.forEach((res, index) => {
          if(res.childrens.length > 1){
            const renderRow=[]
            res.childrens.forEach((e) => {
              if(!renderRow.includes(e.skuUnit)){
                let planAmount = 0;
                let finishAmount = 0;
                renderRow.push(e.skuUnit)
                const fliterList=res.childrens.filter(item=>item.skuUnit===e.skuUnit)
                fliterList.forEach(child=>{
                  planAmount += child.planAmount || 0;
                  finishAmount += child.finishAmount || 0;
                })
                tableList.push({
                  ...e,
                  planAmount,
                  finishAmount,
                  key: e.id,
                  index: index+1,
                  rowSpan: fliterList.length
                })
              }else{
                // finishAmount += e.finishAmount || 0;
                // planAmount += e.planAmount || 0;
                tableList.push({
                  ...e,
                  key: e.id,
                  index: index+1,
                  rowSpan: 0,
                })
              }
            })
            // tableList[index] = {
            //   ...tableList[index],
            //   finishAmount,
            //   index: index+1,
            //   planAmount,
            // }
          }else{
            tableList.push({
              ...res,
              finishAmount: res.finishAmount,
              index: index+1,
              key: res.id,
              rowSpan: 1,
            })
          }
        })
        return tableList
      }
    },
    listData(){
      const data = this.concatList(this.warehouseOrderResList.warehouseOrderGoodsList, 'skuId')
      const tableList = []
      data.forEach((res, index) => {
        if(res.childrens.length > 1){
          const renderRow=[]
          res.childrens.forEach((e) => {
            if(!renderRow.includes(e.skuUnit)){
              let planAmount = 0;
              let finishAmount = 0;
              renderRow.push(e.skuUnit)
              const fliterList=res.childrens.filter(item=>item.skuUnit===e.skuUnit)
              fliterList.forEach(child=>{
                planAmount += child.planAmount || 0;
                finishAmount += child.finishAmount || 0;
              })
              tableList.push({
                ...e,
                planAmount,
                finishAmount,
                key: e.id,
                index: index+1,
                rowSpan: fliterList.length
              })
            }else{
              // finishAmount += e.finishAmount || 0;
              // planAmount += e.planAmount || 0;
              tableList.push({
                ...e,
                key: e.id,
                index: index+1,
                rowSpan: 0,
              })
            }
          })
          // tableList[index] = {
          //   ...tableList[index],
          //   finishAmount,
          //   index: index+1,
          //   planAmount,
          // }
        }else{
          tableList.push({
            ...res,
            finishAmount: res.finishAmount,
            index: index+1,
            key: res.id,
            rowSpan: 1,
          })
        }
      })
      return tableList
    }
  },
  created () {
    // this.getOrderDetail()
  },
  mounted () {},
  methods: {
    downloadDetails({url, name, type=false, imgurl}) {
      const http = new XMLHttpRequest();
      const fromDate = {unifyOdrNo: this.orderDetail.unifyOdrNo}
      
      if(type){
        fromDate.url = imgurl
        fromDate.fileName = name
      }

      http.open("POST", `${Service.OTMS_WEB_PLUS_SERVER}${url}`);
      http.responseType = "blob";
      http.setRequestHeader("Authorization", getToken());
      http.setRequestHeader("Content-Type", 'application/json');
      http.onreadystatechange = () => {
        if (http.status === 200 && http.readyState === 4) {
          const filename = name;
          const blob = new Blob([http.response], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });
          const csvUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = csvUrl;
          link.download = filename;
          link.click();
        }
      };
      http.send(JSON.stringify(fromDate));
    },
    concatList(list, calcId){
        const goodsList = [];
        const sameIds = [];
        list.forEach((item) => {
            const keyList = sameIds.map((e)=>{
                return e.skuId
            })
            const index = keyList.indexOf(item[calcId]);
            if (index > -1 && (sameIds[index].wmsExt?.goodUnit === item.wmsExt?.goodUnit || sameIds[index].wmsExt?.goodsUnit === item.wmsExt?.goodsUnit)) {
                goodsList[index].childrens.push(item);
            } else {
                sameIds.push(item);
                goodsList.push({
                    ...item,
                    childrens: [item],
                });
            }
        });
        return goodsList;
    },
    rowClass(record,index) {
      return `rowSpan${record.skuId}${index}`;
    },
    customRow() {
      return {
        on: {
          mouseenter: (event) => {
            this.mouseAction(event, 'add');
          },
          mouseleave: (event) => {
            this.mouseAction(event, 'remove');
            
          },
        }
      };
    },
    mouseAction(event, type) {
      const { classList } = event.target;
      let currentClass = '';
      for (let i = 0; i < classList.length; i+=1) {
        if (/rowSpan+/.test(classList[i])) {
          currentClass = classList[i];
          break;
        }
      }
      const eles = document.getElementsByClassName(currentClass);
      for (let i = 0; i < eles.length; i+=1) {
        eles[i].classList[type]('ant-table-row-hover');
      }
    },
    // async getOrderDetail() {
    //   this.orderDetail = await featchOrderDetail({
    //     unifyOdrNo: this.odrNo
    //   })
    // },
    onCheckout(index) {
      this.nextIndex = index
    },
    filterTime(time){
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    }
  },
}
</script>

<style lang="less" scoped>
.info-panel {
    margin-top: 10px;
}
.WarehouseOperation {
  background: #fff;
  padding-bottom: 24px;
  min-height: calc(100vh - 200px);
  .info-title {
    margin-top: 24px;
    color: #171717;
    font-size: 16px;
  }
  .descriptions-info {
    border-radius: 0;
  }
}
.operation-type {
  display: inline-block;
  width: 108px;
  height: 40px;
  border-radius: 4px;
  background: #DCDEE0;
  color: #606266;
  text-align: center;
  line-height: 40px;
  img {
    width: 24px;
    height: 24px;
  }
  &.active {
    color: #fff;
    background: linear-gradient(244deg, #06B889 0%, #24D69E 100%);
  }
}
.info-panel-first {
    background-color: #fff;
}
.attachment {
  margin-top: 24px;
  > div {
    margin-left: 33px;
    .attachment-list {
      padding: 16px;
      border: 1px solid #EBEDF0;
      border-radius: 4px;
      margin-top: 16px;
      width: 319px;
      position: relative;
      max-height: 262px;
      overflow-y: auto;
      &::before {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        position: absolute;
        top: -8px;
        border-top: 1px solid #EBEDF0;
        border-left: 1px solid #EBEDF0;
        border-radius: 2px;
        transform: rotate(45deg);
        background: #fff;
      }
      .list-item {
        height: 32px;
        line-height: 32px;
        margin: 8px 0;
        color: #171717;
        .icon_file {
          color: #06B880;
          margin-right: 10px;
        }
        .icon_download {
          font-size: 16px;
          color: #909399;
          &:hover {
            color: #06B880;
          }
        }
        div{
          width: 90%;
          .fileNameStyle{
            display: inline-block;
            vertical-align: middle;
            width: 80%;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
.goods-box {
  background: #fff;
  padding: 0px 0 12px 30px;
}
.ck-goods {
  padding-top: 24px;
}
.goods-table{
  width: 800px;
  // margin-top: 24px;
  margin-bottom: 40px;
}
.btnBox{
  padding: 20px 30px;
  background-color: #fff;
  i{
    margin: 0 10px;
  }
}
.no-data {
  padding: 100px 0 500px;
  text-align: center;
  font-size: 24px;
  color: #ccc;
  background: #fff;
  // margin-top: 20px;
}
.multi-InfoBox-root{
  .InfoBox-root{
    padding: 0 30px;
  }
  .info-title{
    margin-top: 0;
  }
}
.OrderOutData{
  padding:0 24px;
  margin-bottom: 16px;
}
.title_bar{
  padding-left: 24px;
  color: #171717;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 16px;
  font-size: 16px;
  position:relative;
  display: flex;
  align-items: center;
  &::before{
    content:'';
    display: inline-block;
    height: 16px;
    width: 4px;
    background: #06B880;
    border-radius: 2px;
    position: absolute;
    left: 0;
  }
}
</style>